import { Trans, useTranslation } from "react-i18next";
import "./ServicesCoverages.scss";
import {
  Box,
  Checkbox,
  Drawer,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ServicesHeader from "../../ServicesUpdate/ServicesUpdateHeader/ServicesUpdateHeader";
import { useContext, useEffect, useState } from "react";
import TotalEnergiesContext from "../../../core/store/context/TotalEnergiesContext";
import { ManagementUpdateCup } from "../../../core/models/cupsCifSelector/cupsCifSelector.model";
import {
  ManagementRequestInfo,
  PostCallCenterRequestBody,
  RequestStateDescriptionData,
} from "../../../core/models/managements/managements.model";
import {
  getManagementsRequestTypeData,
  initialManagementRequestInfo,
  initialRequestStateData,
} from "../../../utils/components/managements/managements.util";
import theme from "../../../muiTheme";
import CupsCifSelector from "../../CupsCifSelector/CupsCifSelector";
import React from "react";
import ButtonElement from "../../UI/ButtonElement/ButtonElement";
import ManagementsCancelProcess from "../../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import ManagementsRequestState from "../../Managements/ManagementsRequestState/ManagementsRequestState";
import DatePickersComponent from "../../UI/DatePickersComponent/DatePickersComponent";
import {
  ChangeCoveragesData,
  ChangeEventDatePicker,
} from "../../../core/models/services/services.model";
import {
  MANAGEMENTS_STATE_ERROR,
  MANAGEMENTS_STATE_PENDING,
  SERVICES_SUBTYPE_OPTIMIZE_COVERAGES,
} from "../../../core/constants/constants";
import { postCallCenter as postCallCenterFetch } from "../../../core/services/managements/managements.service";
import { formatDate } from "../../../utils/dateUtils/formatDate.util";
import {
  getRecipientId,
  getServiceSubTypeId,
  getServiceTypeId,
} from "../../../utils/components/services/services.util";
import { getSelectedCups } from "../../../utils/components/cupsCifSelector/cupsCifSelector.util";

const ServicesCoverages = () => {
  const { t } = useTranslation();
  const isDesktopViewport = useMediaQuery("(min-width:744px)");
  const isMobileViewport = useMediaQuery("(max-width: 500px )");
  const {
    userData,
    cifCupsState: { listCupsCifFiltered },
  } = useContext(TotalEnergiesContext);
  const [step, setStep] = useState<number>(-2);
  const [selectedCups, setSelectedCups] = useState<ManagementUpdateCup[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<string>("");
  const [requestStateData, setRequestStateData] =
    useState<RequestStateDescriptionData>(initialRequestStateData);
  const [managementRequestInfo, setManagementRequestInfo] =
    useState<ManagementRequestInfo>(initialManagementRequestInfo);

  //Market
  const [marketOption, setMarketOption] = useState("");
  const marketOptions = [
    {
      id: "OTC",
      label: "OTC",
    },
    {
      id: "OMIP",
      label: "OMIP",
    },
  ];
  const marketOnChange = (event: { target: { value: any } }) => {
    setMarketOption(event.target.value);
    setFormData({ ...formData, market: event.target.value });
  };

  //Period
  const [periodOption, setPeriodOption] = useState("");
  const periodOptions = {
    Trimestres: [
      {
        id: "Q1",
        label: "Q+1",
      },
      {
        id: "Q2",
        label: "Q+2",
      },
      {
        id: "Q3",
        label: "Q+3",
      },
    ],
    Años: [
      {
        id: "A1",
        label: "Año+1",
      },
      {
        id: "A2",
        label: "Año+2",
      },
    ],
  };
  const periodOnChange = (event: { target: { value: any } }) => {
    setPeriodOption(event.target.value);
    setFormData({ ...formData, period: event.target.value });
  };

  //Volume
  const [volumeOption, setVolumeOption] = useState("megawatt");
  const volumeOptions = [
    {
      id: "megawatt",
      label: "MW (Megavatios)",
    },
    {
      id: "percentage",
      label: "% (Porcentaje)",
    },
  ];
  const volumeUnitOnChange = ({ target }: any) => {
    setVolumeOption(target.value);
  };

  //Target price
  const [targetpriceOption, setTargetPriceOption] = useState("requestPrice");
  const [fixedPrice, setFixedprice] = useState(false);
  const targetpriceOptions = [
    {
      id: "requestPrice",
      label: "Solicitar cotización",
    },
    {
      id: "fixedPrice",
      label: "Fijar un precio objetivo",
    },
  ];
  const targetpriceOnChange = (event: { target: { value: any } }) => {
    if (event.target.value === "fixedPrice") {
      setFixedprice(true);
    } else {
      setFixedprice(false);
    }
    setTargetPriceOption(event.target.value);
    setFormData({ ...formData, targetPrice: event.target.value });
  };

  //Dates
  const [dateFrom, setDateFrom] = useState<ChangeEventDatePicker | null>(null);
  const [dateTo, setDateTo] = useState<ChangeEventDatePicker | null>(null);

  //Notes
  const [notes, setNotes] = useState<string>("");

  //More info drawer
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  //Open modal
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  //Check filled fields for submit
  const [message, setMessage] = useState("");
  const [isConsentAccepted, setIsConsentAccepted] = useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isDisabledConsent, setIsDisabledConsent] = useState<boolean>(false);

  const [formData, setFormData] = useState<ChangeCoveragesData>({
    market: "",
    period: "",
    volume: "",
    targetPrice: "requestPrice",
    dateFrom: "",
    dateTo: "",
  });

  useEffect(() => {
    const fixedPriceDatesFilled =
      !fixedPrice || (fixedPrice && dateFrom !== null && dateTo !== null);

    const isFieldsFilled =
      formData.market !== "" &&
      formData.period !== "" &&
      formData.targetPrice !== "" &&
      formData.volume !== "" &&
      fixedPriceDatesFilled &&
      selectedCups.length > 0;
    const newVolumeText = formData.volume.includes(",")
      ? formData.volume
      : formData.volume + ",0";

    setMessage(
      `El usuario desea realizar un cambio de Coberturas. Mercado: ${
        formData.market
      }. Periodo: ${formData.period}. Volumen a cerrar: ${newVolumeText} ${
        volumeOption === "percentage" ? "%" : "MW"
      }. Precio objetivo: ${
        formData.targetPrice === "requestPrice"
          ? "solicita cotización."
          : `fijar un precio objetivo`
      } ${
        fixedPrice
          ? ` desde ${formData.dateFrom} hasta ${formData.dateTo}.`
          : ""
      } ${notes ? `Notas: ${notes}.` : ""}`
    );

    setIsDisabled(
      (!isDesktopViewport &&
        isFieldsFilled &&
        fixedPrice &&
        !isConsentAccepted) ||
        (!isDesktopViewport && !isFieldsFilled) ||
        (isDesktopViewport && !isFieldsFilled)
    );

    setIsDisabledConsent(!isConsentAccepted);
  }, [
    formData,
    fixedPrice,
    dateFrom,
    dateTo,
    selectedCups,
    isConsentAccepted,
    isDesktopViewport,
    volumeOption,
    notes,
  ]);

  //Submit form
  const handleSubmit = async () => {
    //If fixedPrice && desktop && step -2, go to step -1
    if (fixedPrice && isDesktopViewport && step === -2) {
      setStep(-1);
    } else {
      if (userData) {
        const idRegisterType = getServiceTypeId(selectedCups[0].envirorment);

        const selectedCupsFiltered = getSelectedCups(
          selectedCups,
          listCupsCifFiltered
        );

        const IdSubTipoReclamacion = getServiceSubTypeId(
          idRegisterType,
          SERVICES_SUBTYPE_OPTIMIZE_COVERAGES
        )

        const requestBody: PostCallCenterRequestBody = {
          TextoIncidencia: message,
          CodigosContratos: selectedCupsFiltered.map(
            ({ cupsContractCode }) => +cupsContractCode
          ),
          IdTipoRegistro: idRegisterType,
          IdsContratos: selectedCupsFiltered.map(
            ({ cupsContractId }) => +cupsContractId
          ),
          IdSubTipoReclamacion,
          idUsuarioDestino: getRecipientId(idRegisterType, IdSubTipoReclamacion),
        };

        setIsLoading(true);
        setStep(1);

        postCallCenterFetch(requestBody, userData.token)
          .then(([{ IdCallCenter }]) => ({
            IdCallCenter,
          }))
          .then(async ({ IdCallCenter }) => {
            setRequestState(MANAGEMENTS_STATE_PENDING);
            setRequestStateData(
              getManagementsRequestTypeData(
                SERVICES_SUBTYPE_OPTIMIZE_COVERAGES,
                MANAGEMENTS_STATE_PENDING
              )
            );
            setManagementRequestInfo({
              registrarionDate: formatDate(new Date()),
              refferenceNumber: IdCallCenter.toString(),
            });
            setIsLoading(false);
          })
          .catch((error) => {
            setRequestState(MANAGEMENTS_STATE_ERROR);
            setRequestStateData(
              getManagementsRequestTypeData(
                SERVICES_SUBTYPE_OPTIMIZE_COVERAGES,
                MANAGEMENTS_STATE_ERROR
              )
            );
            setIsLoading(false);
          });
      }
    }
  };

  return (
    <Box
      component="section"
      className="management-ownership-change"
      paddingBottom={{ md: "5rem" }}
    >
      <ServicesHeader
        title={"Realizar coberturas"}
        step={step}
        showStepper={true}
      />
      {step === -2 && (
        <>
          <Stack
            component="article"
            direction="column"
            justifyContent="center"
            alignItems="center"
            paddingTop={"5rem"}
            paddingBottom={"2.5rem"}
            bgcolor={{ md: theme.palette.grey[50] }}
          >
            <CupsCifSelector
              withContainer
              setUpdateCups={() => {}}
              selectedCups={selectedCups}
              setSelectedCups={setSelectedCups}
              title={"Servicios.¿Dónde quieres aplicar el cambio?"}
              description={
                "Servicios.Selecciona uno o más suministros donde realizar coberturas"
              }
              isManagementsComponent={false}
            />
          </Stack>

          <Stack
            component="article"
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            bgcolor={{ md: theme.palette.grey[50] }}
            paddingLeft={{ xs: "1rem", md: "0" }}
            paddingRight={{ xs: "1rem", md: "0" }}
          >
            <Grid justifyContent="center" container>
              <Grid item md={8} lg={7}>
                <Box component="div" className={"services__box-body"}>
                  <Typography
                    variant="h3"
                    component="h3"
                    paddingBottom={"1.5rem"}
                  >
                    {t("Servicios.Orden de cobertura (click)")}
                  </Typography>

                  <FormControl
                    fullWidth
                    required
                    sx={{
                      display: "flex",
                      gap: "0.5rem",
                      width: { xs: "100%", md: "50%" },
                      paddingBottom: "2rem",
                    }}
                  >
                    <FormLabel sx={{ fontWeight: 600 }}>
                      {t("Servicios.Mercado")}
                      <span style={{ color: "red" }}> *</span>
                    </FormLabel>
                    <Select
                      id="market"
                      value={marketOption}
                      onChange={marketOnChange}
                      displayEmpty
                      sx={{ width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        {t("Servicios.Selecciona OTC o OMIP")}
                      </MenuItem>
                      {marketOptions.map((option) => (
                        <MenuItem key={option.label} value={option.label}>
                          {t(`Servicios.${option.label}`)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl
                    fullWidth
                    required
                    sx={{
                      display: "flex",
                      gap: "0.5rem",
                      width: { xs: "100%", md: "50%" },
                      paddingBottom: "2rem",
                    }}
                  >
                    <FormLabel sx={{ fontWeight: 600 }}>
                      {t("Servicios.Período")}
                      <span style={{ color: "red" }}> *</span>
                    </FormLabel>
                    <Select
                      id="period"
                      value={periodOption}
                      onChange={periodOnChange}
                      displayEmpty
                      sx={{ width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        {t("Servicios.Seleccione un período")}
                      </MenuItem>
                      {Object.entries(periodOptions).map(
                        ([groupLabel, options], index) => [
                          <ListSubheader key={groupLabel}>
                            {t(groupLabel)}
                          </ListSubheader>,
                          ...options.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.label}
                            </MenuItem>
                          )),
                        ]
                      )}
                    </Select>
                  </FormControl>

                  <Box>
                    <FormLabel sx={{ fontWeight: 600 }}>
                      {t("Servicios.Volumen a cerrar")}
                      <span style={{ color: "red" }}> *</span>
                    </FormLabel>
                    <Stack direction={{ xs: "column", md: "row" }} gap={"1rem"}>
                      <FormControl
                        fullWidth
                        required
                        sx={{
                          display: "flex",
                          gap: "0.5rem",
                          width: { xs: "100%", md: "50%" },
                        }}
                      >
                        <OutlinedInput
                          onChange={({ target: { value } }) =>
                            setFormData({ ...formData, volume: value })
                          }
                          type="number"
                          id="volume"
                          placeholder={t(
                            "Servicios.Indique un número con decimales"
                          )}
                        ></OutlinedInput>
                      </FormControl>
                      <FormControl
                        fullWidth
                        required
                        sx={{
                          display: "flex",
                          gap: "0.5rem",
                          width: { xs: "100%", md: "30%" },
                          paddingBottom: "0.5rem",
                        }}
                      >
                        <Select
                          id="volumeUnit"
                          value={volumeOption}
                          onChange={volumeUnitOnChange}
                          displayEmpty
                          sx={{ width: "100%" }}
                        >
                          {volumeOptions.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {t(`Servicios.${option.label}`)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                    <Typography
                      variant="caption"
                      component="p"
                      paddingBottom="2rem"
                    >
                      <Trans i18nKey="Servicios.El volumen a cerrar en MW se refiere a los Megavatios en carga base que se cerrarán durante el periodo seleccionado. Más información.">
                        Link
                        <Typography
                          variant="caption"
                          component="span"
                          sx={{
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsDrawerOpen(true)}
                        >
                          content
                        </Typography>
                      </Trans>
                    </Typography>
                  </Box>

                  <FormControl
                    fullWidth
                    required
                    sx={{
                      display: "flex",
                      gap: "0.5rem",
                      width: { xs: "100%", md: "50%" },
                      paddingBottom: "3rem",
                    }}
                  >
                    <FormLabel sx={{ fontWeight: 600 }}>
                      {t("Servicios.Precio objetivo")}
                      <span style={{ color: "red" }}> *</span>
                    </FormLabel>
                    <Select
                      id="targetPrice"
                      value={targetpriceOption}
                      onChange={targetpriceOnChange}
                      displayEmpty
                      sx={{ width: "100%" }}
                    >
                      {targetpriceOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {t(`Servicios.${option.label}`)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {fixedPrice && (
                    <Box component="div" paddingBottom="3rem">
                      <DatePickersComponent
                        enableFuture
                        noWrap
                        required
                        filters={{ dateFrom, dateTo }}
                        setFilters={(id, value) => {
                          const formattedDate = value
                            ? new Date(value.toString()).toLocaleDateString(
                                "en-GB"
                              )
                            : "";
                          if (id === "dateFrom") {
                            setDateFrom(value);
                            setFormData({
                              ...formData,
                              dateFrom: formattedDate,
                            });
                            return;
                          }
                          setDateTo(value);
                          setFormData({ ...formData, dateTo: formattedDate });
                        }}
                        customTitle="Servicios.Período de vigencia de la orden de precio objetivo"
                      />
                    </Box>
                  )}

                  <Box component="div" paddingBottom="3rem">
                    <Typography
                      component="h3"
                      variant="h3"
                      paddingBottom="1.5rem"
                    >
                      {t("Servicios.Detalle")}
                    </Typography>
                    <FormControl
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <FormLabel
                        required
                        sx={{ display: "flex", direction: "column" }}
                      >
                        <Typography component={"p"}>
                          <Typography component={"span"} fontWeight={600}>
                            {t("Servicios.Nota")}
                          </Typography>
                          {` (${t("Opcional")})`}
                        </Typography>
                      </FormLabel>
                      <TextField
                        multiline
                        rows={10}
                        onChange={({ target: { value } }) => setNotes(value)}
                      />
                    </FormControl>
                    <Typography
                      variant="body2"
                      component="p"
                      color={theme.palette.grey[700]}
                    >
                      {t("Servicios.Aclaración nota")}
                    </Typography>

                    {!isDesktopViewport && fixedPrice && (
                      <Box
                        component="div"
                        display={"flex"}
                        alignItems={"flex-start"}
                        gap={"0.5rem"}
                        paddingTop={1}
                        color={theme.palette.grey[700]}
                      >
                        <Checkbox
                          sx={{ fontSize: "24px" }}
                          onChange={(event) => {
                            setIsConsentAccepted(event.target.checked);
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                          icon={
                            <span className="t-icon-checkbox-default"></span>
                          }
                          checkedIcon={
                            <span className="t-icon t-icon-checkbox-checked"></span>
                          }
                        />
                        <Typography component="p" variant="body2">
                          {t(
                            "Servicios.Doy mi consentimiento para que, una vez quede confirmada la orden por parte de TotalEnergies, esta tenga carácter irrevocable"
                          )}
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "space-between",
                      gap: "1.5rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <ButtonElement
                      disabled={isDisabled}
                      onClick={() => handleSubmit()}
                    >
                      {fixedPrice && isDesktopViewport
                        ? t("Servicios.Siguiente")
                        : t("Servicios.Solicitar cotización")}
                    </ButtonElement>
                    <ButtonElement type="button" secondary onClick={openModal}>
                      {t("Cancelar")}
                    </ButtonElement>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Stack>
        </>
      )}
      {step === -1 && (
        <Stack
          component="article"
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          paddingTop={5}
          paddingBottom={10}
          bgcolor={{ md: theme.palette.grey[50] }}
        >
          <Grid justifyContent="center" container>
            <Grid item md={8} lg={7}>
              <Box component="div" className={"services__box-body"}>
                <Typography
                  variant="h3"
                  component="h3"
                  paddingBottom={"1.25rem"}
                >
                  {t("Servicios.Confirmar orden de cobertura")}
                </Typography>
                <Typography
                  variant="body2"
                  component={"p"}
                  paddingBottom={"1.25rem"}
                >
                  {t(
                    "Servicios.[Texto legal de consentimiento necesita se aportado por el cliente]"
                  )}
                </Typography>
                <Box
                  component="div"
                  display={"flex"}
                  alignItems={"flex-start"}
                  gap={"0.5rem"}
                  paddingBottom={"3rem"}
                >
                  <Checkbox
                    sx={{ fontSize: "24px" }}
                    onChange={(event) => {
                      setIsConsentAccepted(event.target.checked);
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    icon={<span className="t-icon-checkbox-default"></span>}
                    checkedIcon={
                      <span className="t-icon t-icon-checkbox-checked"></span>
                    }
                  />
                  <Typography component="p" variant="body1">
                    {t(
                      "Servicios.Doy mi consentimiento para que, una vez quede confirmada la orden por parte de TotalEnergies, esta tenga carácter irrevocable"
                    )}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    gap: "1rem",
                    marginY: "1.5rem",
                    flexWrap: "wrap",
                  }}
                >
                  <ButtonElement
                    disabled={isDisabledConsent}
                    onClick={() => handleSubmit()}
                  >
                    {t("Servicios.Solicitar cotización")}
                  </ButtonElement>
                  <ButtonElement type="button" onClick={openModal} secondary>
                    {t("Cancelar")}
                  </ButtonElement>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      )}
      {step === 1 && (
        <ManagementsRequestState
          showManagementRequestInfo
          isLoading={isLoading}
          state={requestState}
          managementRequestInfo={managementRequestInfo}
          title={requestStateData.title}
          description={requestStateData.description}
          descriptionExtra={requestStateData.descriptionExtra}
          type="servicios"
        />
      )}
      <ManagementsCancelProcess open={isModalOpen} handleClose={closeModal} />

      {isDrawerOpen && (
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          PaperProps={
            isMobileViewport
              ? { sx: { width: "100%" } }
              : { sx: { width: "31rem" } }
          }
        >
          <Box
            component="div"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="1.5rem 2.25rem"
            className="bills-filter-box"
          >
            <Typography component="h3" variant="h3">
              {t("Servicios.Más información")}
            </Typography>
            <IconButton disableRipple onClick={() => setIsDrawerOpen(false)}>
              <span className="t-icon-close brand-red" />
            </IconButton>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={"2rem"}
            padding="2rem 2.5rem"
          >
            <Stack direction={"column"} gap={"1rem"}>
              <Typography variant="body2">
                <Trans i18nKey="Más información coberturas">
                  {t("Servicios.Más información coberturas")}
                </Trans>
              </Typography>
            </Stack>

            <Stack direction={"column"} gap={"1rem"}>
              <Typography variant="body2" color={theme.palette.grey[700]}>
                <Trans i18nKey="Más información coberturas">
                  {t("Servicios.Más información coberturas nota ejemplo")}
                </Trans>
              </Typography>
            </Stack>
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default ServicesCoverages;
